import { Link } from 'react-router';

const IndexBack = () =>{

    return (
        <div style={{ minHeight: '50vh', display: 'grid' }} className="Center Horizontally Vertically">
        <div className="BackWrapper">
            <h1 className="CenterText Back" >
                Get a Free Professional Resume in Minutes
            </h1>
            <br />
            <p className="CenterText">
                No design skills needed — fill the form, get your resume, and go.
            </p>
            <hr />
            <br />
            <div className="Center Horizontally">
                <Link to="/templates" className="CenterText cuslink white signup">
                    Create Resume
                </Link>
            </div>
        </div>
    </div>
    )
}

export default IndexBack;